// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EventsCreatePage {
  min-height: 100vh;
  background: #f5f5f5;
  padding-left: 280px;
  width: 100%;
  box-sizing: border-box;
}
@media (max-width: 800px) {
  .EventsCreatePage {
    padding-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/EventsCreatePage/EventsCreatePage.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AACF;AACE;EAPF;IAQI,eAAA;EAEF;AACF","sourcesContent":[".EventsCreatePage {\n  min-height: 100vh;\n  background: #f5f5f5;\n  padding-left: 280px; // Ширина сайдбара\n  width: 100%;\n  box-sizing: border-box;\n\n  @media (max-width: 800px) {\n    padding-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"EventsCreatePage": `EventsCreatePage`
};
export default ___CSS_LOADER_EXPORT___;
